import { Component, DestroyRef, OnInit, input, output, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CompanyProfile, CompanySearchResult } from '@app/core/stingray-api/models';
import { CompanyInfoService } from '@app/core/stingray-api/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatPrefix, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'unite-company-autocomplete',
    templateUrl: './company-autocomplete.component.html',
    styleUrls: ['./company-autocomplete.component.scss'],
    imports: [MatFormField, MatIcon, MatPrefix, MatLabel, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatProgressSpinner, MatSuffix, MatAutocomplete, MatOption]
})
export class CompanyAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  appearance = input<string>('outline');
  label = input<string>('Company name');
  class = input<string>();

  companySelected = output<CompanyProfile>();

  isSearchingCompanies = false;
  companySearchResults: CompanySearchResult[] = [];

  translatedLabel = '';

  constructor(
    private translatorService: TranslateService,
    private companyInfoService: CompanyInfoService) {
  }

  ngOnInit() {

    this.translatedLabel = this.translatorService.instant(this.label());

    this.control().valueChanges
    .pipe(
      debounceTime(350),
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef))
    .subscribe(value => {

      if (value ) {
        // Start a search
        if (typeof value === 'string' && value.trim() !== '') {
          this.isSearchingCompanies = true;
          this.companyInfoService.findCompanies({ tradeName: value, count: 10 })
            .pipe(finalize(() => this.isSearchingCompanies = false), takeUntilDestroyed(this.destroyRef))
            .subscribe((companySearchResults) => {
              this.companySearchResults = companySearchResults;
            });
        } else {
          this.selectCompanySearchResult(value);
        }
      }

    });
  }



  selectCompanySearchResult(result: CompanySearchResult): void {
    if (result) {
      // Company info search result
      this.companyInfoService
      .getCompanyProfile({chamberOfCommerceNumber: result.chamberOfCommerceNumber})
      .subscribe(companyProfile => {
        this.companySelected.emit(companyProfile);
      });
    }
  }

  displayCompanySearchResult(result: any): string {
    if(typeof result === 'string' && result.trim() !== '' ) {
      return result;
    } else {
      return result?.name;
    }
  }
}
